"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parkingEndError = exports.parkingStartError = exports.error = void 0;
const typebox_1 = require("@sinclair/typebox");
const enums_1 = require("../enums");
/**
 * Defines the error format used by the validation build into Fastify.
 * This format should also be used for custom errors.
 */
// eslint-disable-next-line import/prefer-default-export
exports.error = typebox_1.Type.Object({
    statusCode: typebox_1.Type.Number({
        description: 'error status code',
        example: 401,
    }),
    error: typebox_1.Type.String({
        description: 'error type',
        example: 'Unauthorized',
    }),
    message: typebox_1.Type.String({
        description: 'error message',
        example: 'invalid credentials',
    }),
});
exports.parkingStartError = typebox_1.Type.Intersect([
    exports.error,
    typebox_1.Type.Object({
        reason: typebox_1.Type.Enum(enums_1.ParkingStartError, {
            description: 'reason why parking start failed',
            example: enums_1.ParkingStartError.AreaFull,
        }),
    }),
]);
exports.parkingEndError = typebox_1.Type.Intersect([
    exports.error,
    typebox_1.Type.Object({
        reason: typebox_1.Type.Enum(enums_1.ParkingEndError, {
            description: 'reason why parking end failed',
            example: enums_1.ParkingEndError.NoVehicleAtGate,
        }),
    }),
]);
//# sourceMappingURL=error.js.map